<template>
  <div class="box">
    <div class="typeArea">
      <div class="progress-item" :class="index%2==0?'progress-item-right':'progress-item-left'" v-for="(history,index) in history" :key="index">
        <div class="progress-bar">
          <img class="progress-bar-dot" src="@/assets/images/dot.png" alt="">
          <div class="progress-bar-dashed"></div>
        </div>
        <div class="context">
          <div class="title">{{history.year}}</div>
          <div class="monthInfo" v-for="(month,index) in history.monthList" :key="index">
            <div class="month">{{month.month}}</div>
            <div v-for="(event,index) in month.eventList" :key="index">
              <div class="info">{{event.info}}</div>
              <div class="department">{{event.department}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="progress-item progress-item-right">
      <div class="progress-bar">
        <img class="progress-bar-dot" src="@/assets/images/dot.png" alt="">
        <div class="progress-bar-dashed"></div>
      </div>
      <div class="context">
        <div class="title">2008</div>
        <div class="monthInfo">
          <div class="month"></div>
          <div class="info"></div>
          <div class="department">环境保护部</div>
        </div>
      </div>
    </div>
    <div class="progress-item progress-item-left">
      <div class="progress-bar">
        <img class="progress-bar-dot" src="@/assets/images/dot.png" alt="">
        <div class="progress-bar-dashed"></div>
      </div>
      <div class="context">
        <div class="title">2010</div>
        <div class="monthInfo">
          <div class="month">11月</div>
          <div class="info">《化学物质测试机构》</div>
          <div class="department">环境保护部</div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'developmentHistory',
  data () {
    return {
      history:[
        {
          year: 2008,
          monthList:[
            {
              month: "",
              eventList:[
                {
                  info: "创始团队在原贵州省理化测试分析研究中心建立GLP体系，开展GLP业务。",
                  department: ""
                }
              ]
            }
          ]
        },
        {
          year: 2010,
          monthList:[
            {
              month: "11月",
              eventList:[
                {
                  info: "《化学物质测试机构》",
                  department: "环境保护部"
                }
              ]
            }
          ]
        },
        {
          year: 2013,
          monthList:[
            {
              month: "1月",
              eventList:[
                {
                  info: "《农药登记试验单位》——原药全组分分析",
                  department: "农业农村部"
                }
              ]
            }
          ]
        },
        {
          year: 2014,
          monthList:[
            {
              month: "8月",
              eventList:[
                {
                  info: "《农药登记试验单位》——环境毒理",
                department: "农业农村部"
                }
              ]
            }
          ]
        },
        {
          year: 2015,
          monthList:[
            {
              month: "2月",
              eventList:[
                {
                  info: "CNAS GLP《良好实验室规范符合性证书》",
                  department: "国家认可委"
                },
                {
                  info: "《化学品测试合格实验室》",
                  department: "环境保护部"
                },
              ]
            },
            {
              month: "11月",
              eventList:[          
                {
                  info: "成立贵州健安德科技有限公司，独立运行GLP实验室。",
                  department: ""
                }
              ]
            },
          ]
        },
        {
          year: 2016,
          monthList:[
            {
              month: "8月",
              eventList:[
                {
                  info: "《农药登记试验单位》——全组分分析、理化分析（公告更新）",
                  department: "农业农村部"
                }
              ]
            },
            {
              month: "11月",
              eventList:[
                {
                  info: "《化学品物理危险性鉴定机构》",
                  department: "国家安监局"
                }
              ]
            },
            {
              month: "12月",
              eventList:[
                {
                  info: "《实验动物使用许可证》",
                  department: "贵州省科技厅"
                }
              ]
            },
          ]
        },
        {
          year: 2018,
          monthList:[
            {
              month: "3月",
              eventList:[
                {
                  info: "《检验检测机构资质认定证书》",
                  department: "CMA"
                }
              ]
            },
            {
              month: "10月",
              eventList:[
                {
                  info: "《实验动物使用许可证-SPF》",
                  department: "贵州省科技厅"
                }
              ]
            },
          ]
        },
        {
          year: 2019,
          monthList:[
            {
              month: "3月",
              eventList:[
                {
                  info: "《农药登记试验单位》——产品化学、毒理学、环境影响",
                  department: "农业农村部"
                }
              ]
            },
          ]
        },
        {
          year: 2020,
          monthList:[
            {
              month: "5月",
              eventList:[
                {
                  info: "获A轮融资，融资金额数千万元人民币。",
                  department: ""
                }
              ]
            },
            {
              month: "7月",
              eventList:[
                {
                  info: "《管理体系认证证书》",
                  department: "中标合信"
                }
              ]
            }
          ]
        },
        {
          year: 2021,
          monthList:[
            {
              month: "6月",
              eventList:[
                {
                  info: "CNAS 《实验室认可证书》",
                  department: "国家认可委"
                }
              ]
            },
            {
              month: "9月",
              eventList:[
                {
                  info: "《贵州省病原微生物实验室BSL-2》",
                  department: "贵阳市卫健局"
                }
              ]
            }
          ]
        },
        {
          year: 2022,
          monthList:[
            {
              month: "1月",
              eventList:[
                {
                  info: "《知识产权管理体系认证证书》",
                  department: "中知认证"
                }
              ]
            },
            {
              month: "5月",
              eventList:[
                {
                  info: "《化妆品注册和备案检验检测机构》—— 微生物、理化、毒理",
                  department: "国家药监局"
                }
              ]
            },
          ]
        },
        {
          year: 2023,
          monthList:[
            {
              month: "2月",
              eventList:[
                {
                  info: "《化妆品注册和备案检验检测机构》——人体安全性与功效评价检验",
                  department: "国家药监局"
                }
              ]
            },
          ]
        },
      ]
    }
  },
  methods: {},
  mounted(){
  }
}
</script> 

<style lang='less' scoped>
  .box{
    padding-bottom: 80px;
    overflow: hidden;
    background-image: url("../../assets/images/image49.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center -800px;
    .progress-item-left{
      display: flex;
      flex-direction: row-reverse;
      right: 50%;
      transform: translateX(32px);
      text-align: right;
    }
    .progress-item-right{
      left: 50%;
    }
    .progress-item{
      position: relative;
      display: flex;
      .progress-bar{
        position: relative;
        .progress-bar-dot{
          height: 32px;
          width: 32px;
          position: relative;
          z-index: 2;
        }
        .progress-bar-dashed{
          position: absolute;
          width: 1px;
          height: 100%;
          left: 50%;
          top: 0;
          z-index: 1;

          background-image: linear-gradient(#000 70%, rgba(255,255,255,0) 0%); /* 70%设置虚线点y轴上的长度 */
          background-position: left; /* right配置右边框位置的虚线 */
          background-size: 1px 20px; /* 第一个参数设置虚线点x轴上的长度；第二个参数设置虚线点的间距 */
          background-repeat: repeat-y;
        }
      }
      .context{
        margin: 0 50px;
        .title{
          font-size: 42px;
          font-weight: bold;
          line-height: 35px;
          margin-bottom: 15px;
        }
        .monthInfo{
          .month{
            color: #DB0000;
            font-weight: bold;
            font-size: 15px;
          }
          .info{
            font-size: 16px;
            color: #333333;
            margin-top: 3px;
          }
          .department{
            font-size: 12px;
            color: #333333;
            margin-top: 3px;
            margin-bottom: 20px;
          }
        }
      }
    }
  }
</style>
